<div class="w-100 d-flex justify-content-between py-6">
  <hr class="w-100">
  <h1 class="w-25 text-center" translate>search.users</h1>
  <hr class="w-100">
</div>
<ng-container *ngIf="data$  | async as users">
  <div class="card">
    <div class="table-responsive card-body">
      <table
      class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4"
      >
        <thead>
          <tr class="fw-bolder text-muted">
            <th scope="col"  class="min-w-50px cursor-pointer d-none d-md-table-cell" translate>profile.avatar</th>
            <th scope="col"  class="min-w-120px cursor-pointer d-none d-md-table-cell" translate>groups.first_name</th>
            <th scope="col"  class="min-w-120px cursor-pointer d-none d-md-table-cell" translate>groups.last_name </th>
            <th scope="col"  class="min-w-140px cursor-pointer d-none d-md-table-cell" translate>AUTH.INPUT.EMAIL</th>
            <th scope="col"  class="min-w-140px cursor-pointer d-none d-md-table-cell" translate>AUTH.INPUT.ROLE</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users">
            <td class="d-none d-md-table-cell text-muted fw-bold">
<!--              <img-->
<!--                lcmsAvatarAsLetter-->
<!--                [email]="user?.email"-->
<!--                [border]="'0'"-->
<!--                class=" align-self-end"-->
<!--                alt="Responsive image"-->
<!--              />-->
              <img
               lcmsAvatarPlaceHolder
                [src]="'./assets/passport/abstract-user-flat-1.svg'"
                class="avatar-image align-self-end"
                alt="Responsive image"
              />
            </td>
            <td class="d-none d-md-table-cell text-uppercase text-black fw-bolder fw-bold ps-3">
              {{user?.first_name}}
            </td>
            <td class="d-none d-md-table-cell text-uppercase text-black fw-bolder fw-bold ps-3">
              {{user?.last_name}}
            </td>
            <td class="d-none d-md-table-cell text-black fw-bolder fw-bold ps-3">
              {{user?.email}}
            </td>
            <td class="d-none d-md-table-cell text-black fw-bold ps-3">
              <span class="bg-light-primary p-2 rounded">
                {{user.role | translate}}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>
